import React, { useState } from "react";
import { useOutletContext } from 'react-router-dom';
import { UploadSummaryCard } from "./components/UploadSummaryCard";
import { UploadRosterCard } from "./components/UploadRosterCard";
import { TeamOverviewHeader } from "./components/TeamOverviewHeader";
import { PlayerTable } from "../UncommittedTracker/PlayerTable";
import { CoachSidebar } from '../../../components/coach/dashboard/CoachSidebar';

export const TeamAnalysisPage = () => {
  const { activeView } = useOutletContext();
  const [players, setPlayers] = useState([]);
  const [uploadInfo, setUploadInfo] = useState(null);

  const handleParsedPlayers = (parsedPlayers) => {
    setPlayers(parsedPlayers);

    // Calculate upload info from parsed players
    if (parsedPlayers.length > 0) {
      const totalAvg = parsedPlayers.reduce((sum, p) => sum + (parseFloat(p.avg) || 0), 0);
      setUploadInfo({
        count: parsedPlayers.length,
        avg: totalAvg / parsedPlayers.length,
        weakness: "CATCHER", // You can calculate this based on positions
        strengths: "SPEED & PITCHING", // You can calculate this based on stats
      });
    }
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
      {/* Left Sidebar */}
      <div className="lg:col-span-1 ">
        <CoachSidebar activeView={activeView} />
      </div>

      {/* Right Content Area */}
      <section className="lg:col-span-3 w-full max-w-7xl mx-auto px-3 sm:px-4 md:px-6 lg:px-8 py-4 sm:py-6 md:py-8 bg-jp-card border border-jp-line rounded-3xl shadow-sm">
      {/* Top two cards */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 sm:gap-4 md:gap-6 mb-4 sm:mb-6">
        <UploadSummaryCard />
        <UploadRosterCard onParsedPlayers={handleParsedPlayers} />
      </div>

      {/* Show content only when CSV data is uploaded */}
      {players.length > 0 ? (
        <>
          {/* Your Team Overview */}
          <div className="bg-jp-section rounded-2xl border border-jp-line">
            <TeamOverviewHeader uploadInfo={uploadInfo} />
          </div>

          {/* Player Table */}
          <div className="mt-4 sm:mt-6 overflow-x-auto">
            <PlayerTable data={players} />
          </div>
        </>
      ) : (
        <div className="mt-6 sm:mt-8 text-center py-8 sm:py-12 bg-jp-section rounded-2xl border border-jp-line">
          <p className="text-jp-muted text-xs sm:text-sm px-4">
            Upload a CSV file to view your team analysis
          </p>
        </div>
      )}
    </section>
    </div>
  );
};
